import React, { Component } from 'react';

import camOffLine from '../../../assets/cameraOffline.png';

import axios from 'axios';

import style from './webCam.module.css';
import genericApi from '../../../api/genericApi';
import { baseUrl } from '../../../api/baseUrl';

interface WebcamProps { 
  cam: { url: string, description: string } | null ;
  type?: string;
  ghaId: number;
};

interface WebcamSate { 
  source: string;
  interval: number;
  description: string;
};

class WebCamContainer extends Component<WebcamProps, WebcamSate> {
  
  state = {
    source: camOffLine,
    interval: 1,
    description: ''
  };

  intervalID: ReturnType<typeof setTimeout> = setTimeout(() => {}, 0);


  componentDidUpdate(prevProps: WebcamProps, prevState: WebcamSate) {

    if(prevProps.cam !== this.props.cam) {

      clearInterval(this.intervalID);
      this.load();
      this.intervalID = setInterval(this.load, 30000);
    }
    if (prevState.interval !== this.state.interval) {

      clearInterval(this.intervalID);
      this.load();
      this.intervalID = setInterval(this.load, this.state.interval);
    }
  };

  componentWillUnmount() {
    clearInterval(this.intervalID);
  }

  load = (): void => {
    
    if(this.props.cam) {
      if(this.props.cam.url.startsWith('https://')) {
        this.setState({
          source: this.props.cam.url,
          interval: 15000
        })
      } else {
        axios.get(baseUrl + `camera?url=${encodeURIComponent(this.props.cam.url)}&gha=${this.props.ghaId}`, {
          responseType: 'arraybuffer',
          withCredentials: true
        }).then((resp: any) => {
          if(resp.headers['content-type'].startsWith('application/json')) {
            this.setState({
              source: camOffLine,
              interval: 60000
            })
          } else {
            const base64: string = _arrayBufferToBase64(resp.data);
            this.setState({
              source: `data:${resp.headers['content-type']};base64,` + base64,
              interval: 15000
            })
          }
        }).catch((err: any)=> {
            this.setState({
              source: camOffLine,
              interval: 60000
            })
        })
      }
    }
  };

    
  render() {

    const wrapper: string = this.props.type ? '' : style.wrapper;
    const imgStyle: string = this.props.type ? style.imageMobile : style.imageDesktop;

    return (
      <div className={ wrapper } >

        { this.props.type !== 'mobile' &&
          <div className={ style.description }>{ this.state.description }</div>
        }

        <img className={ imgStyle } src={ this.state.source } />

      </div>
    )
  };
};

function _arrayBufferToBase64( buffer: ArrayBuffer ) {
  var binary = '';
  var bytes = new Uint8Array( buffer );
  var len = bytes.byteLength;
  for (var i = 0; i < len; i++) {
      binary += String.fromCharCode( bytes[ i ] );
  }
  return window.btoa( binary );
}

export default WebCamContainer;